var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "3 2.5 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 15.0762C28 21.3154 23.4287 26.4868 17.4531 27.4243V18.6895H20.3657L20.9199 15.0762H17.4531V12.7314C17.4531 11.7427 17.9375 10.7793 19.4902 10.7793H21.0664V7.70313C21.0664 7.70313 19.6357 7.45898 18.2681 7.45898C15.4131 7.45898 13.5469 9.18945 13.5469 12.3223V15.0762H10.373V18.6895H13.5469V27.4243C7.57129 26.4868 3 21.3154 3 15.0762C3 8.17285 8.59668 2.57617 15.5 2.57617C22.4033 2.57617 28 8.17285 28 15.0762Z",
    fill: "#1877F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.478127a620442780e7fc938936d2f09c.svg";
export { ForwardRef as ReactComponent };